module.exports = __webpack_public_path__ + "img/resources-768.8d99ad49.jpg";